import React, { useState, useEffect } from 'react';
import { Button } from '../../components/ui/button';
import { Textarea } from '../../components/ui/textarea';
import { Card, CardContent } from '../../components/ui/card';
import api from '../../lib/api';
import { toast } from 'sonner';
import { Loader2, Flag, Send, AlertTriangle } from 'lucide-react';

function ComplaintsTab() {
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  
  var viewState = useState('against');
  var view = viewState[0];
  var setView = viewState[1];
  
  var againstState = useState([]);
  var against = againstState[0];
  var setAgainst = againstState[1];
  
  var filedState = useState([]);
  var filed = filedState[0];
  var setFiled = filedState[1];

  useEffect(function() {
    setLoading(true);
    Promise.all([
      api.getComplaintsAgainstMe(),
      api.getMyComplaints()
    ]).then(function(res) {
      setAgainst(res[0].data.complaints || []);
      setFiled(res[1].data.complaints || []);
    }).catch(function(err) {
      console.error(err);
    }).finally(function() {
      setLoading(false);
    });
  }, []);

  function formatDate(d) {
    return d ? new Date(d).toLocaleDateString() : 'N/A';
  }

  var list = view === 'against' ? against : filed;
  var pending = against.filter(function(c) { return !c.accused_response && c.status === 'submitted'; }).length;

  return (
    <div className="space-y-6" data-testid="complaints-tab">
      <div className="flex gap-2">
        <Button
          variant={view === 'against' ? 'default' : 'outline'}
          onClick={function() { setView('against'); }}
          className={view === 'against' ? 'btn-accent' : 'border-slate-700'}
        >
          <AlertTriangle className="h-4 w-4 mr-2" />
          Against Me {pending > 0 && <span className="ml-2 px-2 py-0.5 text-xs rounded-full bg-red-500">{pending}</span>}
        </Button>
        <Button
          variant={view === 'filed' ? 'default' : 'outline'}
          onClick={function() { setView('filed'); }}
          className={view === 'filed' ? 'btn-accent' : 'border-slate-700'}
        >
          <Send className="h-4 w-4 mr-2" />
          Filed by Me
        </Button>
      </div>

      {loading ? (
        <div className="flex justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-teal-400" />
        </div>
      ) : list.length === 0 ? (
        <Card className="card-base">
          <CardContent className="py-12 text-center">
            <Flag className="h-12 w-12 mx-auto text-slate-600 mb-4" />
            <p className="text-slate-400">{view === 'against' ? 'No complaints against you' : 'You have not filed any complaints'}</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-4">
          {list.map(function(c) {
            return (
              <Card key={c.id} className="card-base">
                <CardContent className="p-4">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="text-white font-medium">{c.category_label}</p>
                      <p className="text-sm text-slate-400 mt-1">
                        {view === 'against' ? 'Filed by: ' + c.complainant_name : 'Against: ' + c.accused_name}
                      </p>
                      <p className="text-xs text-slate-500 mt-1">
                        Incident: {formatDate(c.incident_date)} | Status: {c.status}
                      </p>
                    </div>
                    <span className={'px-2 py-1 text-xs rounded capitalize ' + 
                      (c.status === 'resolved' ? 'bg-emerald-500/20 text-emerald-400' : 
                       c.status === 'submitted' ? 'bg-amber-500/20 text-amber-400' : 'bg-slate-500/20 text-slate-400')}>
                      {c.status}
                    </span>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ComplaintsTab;
